const { safeFetch } = require("../utils/safeFetch");

export const printDocument = async (payload, token, tenant) => {
    const response = await fetch(`/api/printers/print`, { // possibilmente usare safeFetch
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(payload), //payload formato da id stanza e testo da stampare
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
}

export const draftPayment = async (payload, token, tenant) => {
    const response = await fetch(`/api/printers/draft`, { // possibilmente usare safeFetch
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(payload), //payload formato da id stanza e testo da stampare
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
}

export const fiscalReceipt = async (payload, token, tenant) => {
    const response = await fetch(`/api/printers/fiscal`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(payload),
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
}

export const fiscalDailyClosure = async (token, tenant, options = {}) => {
    const response = await safeFetch(`/api/printers/fiscal-daily-closure`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(options),
    });

    const data = await response.json().catch(() => null);
    if (!response.ok) {
        throw new Error(data?.error || data?.message || `HTTP error! status: ${response.status}`);
    }
    return data;
}

export const getConfiguredFiscalDevices = async (token, tenant) => {
    const response = await safeFetch('/api/printers/fiscal-devices', {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
}

export const offlinePrintDocument = async (payload, token, tenant) => {
    const response = await safeFetch(`/api/printers/offline-print`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
        body: JSON.stringify(payload), //payload formato da id stanza e testo da stampare
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json()
}

export const getConfiguredPrinters = async (token, tenant) => {
    const response = await safeFetch(`/api/printers/configured`, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'x-tenant-id': tenant,
        },
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.json();
}
